import axios from 'axios';

class GoogleSearchService {
  constructor() {
    this.baseUrl = process.env.REACT_APP_BACKEND_URL;
  }

  async searchEducationalContent(competence, userId, token, language, country) {
    if (!token || !userId || !competence?.title) {
      throw new Error('Missing required parameters');
    }

    try {
      const response = await axios({
        method: 'post',
        url: `${this.baseUrl}/api/search/google`,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        data: {
          query: competence.title,
          userObjective: competence.theme,
          userLanguage: language,
          userCountry: country
        }
      });

      if (!response.data?.results) {
        throw new Error('Invalid response format');
      }

      return this.formatResults(response.data.results);

    } catch (error) {
      console.error('Search error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      throw error;
    }
  }

  formatResults(results) {
    if (!Array.isArray(results)) {
      console.error('Invalid results format:', results);
      return [];
    }

    return results.map(result => ({
      id: result.id || `${Date.now()}-${Math.random()}`,
      title: result.title,
      snippet: result.extract,
      url: result.type === 'synthesis' ? '#' : result.url,
      source: result.source,
      type: result.type,
      language: result.language || 'fr',
      thumbnail: result.thumbnail || null,
      datePublished: result.datePublished || null,
      relevanceScore: Number(result.relevanceScore || 0) 
    }));
  }
}

export default new GoogleSearchService();